import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-models-form',
  templateUrl: './app-models-form.component.html',
  styleUrls: ['./app-models-form.component.css']
})
export class AppModelsFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
